module.exports = __webpack_public_path__ + "media/Goosander.b6073a19.mp3";